module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "background": "#f8f8f8",
      "padding": "0.2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('van-divider', [_vm._v("考试信息")]), _vm._v(" "), (_vm.list.length > 0) ? _c('van-cell-group', [_c('van-field', {
    attrs: {
      "value": _vm.exame.extra_data.danwei + '(' + _vm.exame.extra_data.datetitle + ')',
      "readonly": "",
      "label": "单位",
      "input-align": "right"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "value": (_vm.formData.currentIndex + 1) + '/' + _vm.list.length,
      "readonly": "",
      "label": "当前/总人数",
      "input-align": "right"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "value": (_vm.user.name) + ' (' + _vm.user.type + ')',
      "readonly": "",
      "label": "裁判信息",
      "input-align": "right"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-divider', [_vm._v("考生信息")]), _vm._v(" "), (_vm.list.length > 0) ? _c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "label": "姓名",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex].name),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], "name", $$v)
      },
      expression: "list[formData.currentIndex].name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "星级",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex].grade),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], "grade", $$v)
      },
      expression: "list[formData.currentIndex].grade"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "label": "证件号",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex].num),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], "num", $$v)
      },
      expression: "list[formData.currentIndex].num"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-divider', [_vm._v("评分信息")]), _vm._v(" "), (_vm.list.length > 0 && _vm.user.type == '考官') ? _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入分数'
      }],
      "error-message-align": "right",
      "label": "翻腾",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入分数"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_fanteng' + _vm.user.index]),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_fanteng' + _vm.user.index, $$v)
      },
      expression: "list[formData.currentIndex]['score_fanteng'+user.index]"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入分数'
      }],
      "error-message-align": "right",
      "label": "转体",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入分数"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_zhuanti' + _vm.user.index]),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_zhuanti' + _vm.user.index, $$v)
      },
      expression: "list[formData.currentIndex]['score_zhuanti'+user.index]"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入分数'
      }],
      "error-message-align": "right",
      "label": "跳跃",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入分数"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_tiaoyue' + _vm.user.index]),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_tiaoyue' + _vm.user.index, $$v)
      },
      expression: "list[formData.currentIndex]['score_tiaoyue'+user.index]"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入分数'
      }],
      "error-message-align": "right",
      "label": "平衡柔韧",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入分数"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_pingheng' + _vm.user.index]),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_pingheng' + _vm.user.index, $$v)
      },
      expression: "list[formData.currentIndex]['score_pingheng'+user.index]"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入分数'
      }],
      "error-message-align": "right",
      "label": "力量素质",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入分数"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_liliang' + _vm.user.index]),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_liliang' + _vm.user.index, $$v)
      },
      expression: "list[formData.currentIndex]['score_liliang'+user.index]"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入分数'
      }],
      "error-message-align": "right",
      "label": "动作组合",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入分数"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_dongzuo' + _vm.user.index]),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_dongzuo' + _vm.user.index, $$v)
      },
      expression: "list[formData.currentIndex]['score_dongzuo'+user.index]"
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.exame.year_type == 2),
      expression: "exame.year_type==2"
    }],
    attrs: {
      "rules": [{
        required: true,
        message: '请输入分数'
      }],
      "error-message-align": "right",
      "label": "速度与灵敏",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入分数"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_sudu' + _vm.user.index]),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_sudu' + _vm.user.index, $$v)
      },
      expression: "list[formData.currentIndex]['score_sudu'+user.index]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.list.length > 0 && _vm.user.type == '监督') ? _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "翻腾1",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_fanteng1']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_fanteng1', $$v)
      },
      expression: "list[formData.currentIndex]['score_fanteng1']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "翻腾2",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_fanteng2']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_fanteng2', $$v)
      },
      expression: "list[formData.currentIndex]['score_fanteng2']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "翻腾3",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_fanteng3']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_fanteng3', $$v)
      },
      expression: "list[formData.currentIndex]['score_fanteng3']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "翻腾4",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_fanteng4']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_fanteng4', $$v)
      },
      expression: "list[formData.currentIndex]['score_fanteng4']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "转体1",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_zhuanti1']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_zhuanti1', $$v)
      },
      expression: "list[formData.currentIndex]['score_zhuanti1']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "转体2",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_zhuanti2']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_zhuanti2', $$v)
      },
      expression: "list[formData.currentIndex]['score_zhuanti2']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "转体3",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_zhuanti3']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_zhuanti3', $$v)
      },
      expression: "list[formData.currentIndex]['score_zhuanti3']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "转体4",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_zhuanti4']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_zhuanti4', $$v)
      },
      expression: "list[formData.currentIndex]['score_zhuanti4']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "跳跃1",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_tiaoyue1']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_tiaoyue1', $$v)
      },
      expression: "list[formData.currentIndex]['score_tiaoyue1']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "跳跃2",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_tiaoyue2']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_tiaoyue2', $$v)
      },
      expression: "list[formData.currentIndex]['score_tiaoyue2']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "跳跃3",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_tiaoyue3']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_tiaoyue3', $$v)
      },
      expression: "list[formData.currentIndex]['score_tiaoyue3']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "跳跃4",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_tiaoyue4']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_tiaoyue4', $$v)
      },
      expression: "list[formData.currentIndex]['score_tiaoyue4']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "平衡柔韧1",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_pingheng1']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_pingheng1', $$v)
      },
      expression: "list[formData.currentIndex]['score_pingheng1']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "平衡柔韧2",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_pingheng2']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_pingheng2', $$v)
      },
      expression: "list[formData.currentIndex]['score_pingheng2']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "平衡柔韧3",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_pingheng3']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_pingheng3', $$v)
      },
      expression: "list[formData.currentIndex]['score_pingheng3']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "平衡柔韧4",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_pingheng4']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_pingheng4', $$v)
      },
      expression: "list[formData.currentIndex]['score_pingheng4']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "力量素质1",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_liliang1']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_liliang1', $$v)
      },
      expression: "list[formData.currentIndex]['score_liliang1']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "力量素质2",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_liliang2']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_liliang2', $$v)
      },
      expression: "list[formData.currentIndex]['score_liliang2']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "力量素质3",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_liliang3']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_liliang3', $$v)
      },
      expression: "list[formData.currentIndex]['score_liliang3']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "力量素质4",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_liliang4']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_liliang4', $$v)
      },
      expression: "list[formData.currentIndex]['score_liliang4']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "动作组合1",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_dongzuo1']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_dongzuo1', $$v)
      },
      expression: "list[formData.currentIndex]['score_dongzuo1']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "动作组合2",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_dongzuo2']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_dongzuo2', $$v)
      },
      expression: "list[formData.currentIndex]['score_dongzuo2']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "动作组合3",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_dongzuo3']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_dongzuo3', $$v)
      },
      expression: "list[formData.currentIndex]['score_dongzuo3']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "动作组合4",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_dongzuo4']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_dongzuo4', $$v)
      },
      expression: "list[formData.currentIndex]['score_dongzuo4']"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "总分",
      "readonly": "",
      "input-align": "right"
    },
    model: {
      value: (_vm.list[_vm.formData.currentIndex]['score_total']),
      callback: function($$v) {
        _vm.$set(_vm.list[_vm.formData.currentIndex], 'score_total', $$v)
      },
      expression: "list[formData.currentIndex]['score_total']"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "2rem",
      "background": "rgb(248, 248, 248)"
    }
  }), _vm._v(" "), _c('div', [_c('van-button', {
    staticStyle: {
      "bottom": "60px",
      "right": "10px",
      "position": "fixed",
      "width": "2rem"
    },
    attrs: {
      "native-type": "button",
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "disabled": _vm.scoreSaveLoading,
      "loading": _vm.scoreSaveLoading,
      "loading-text": "确认中...",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.scoreStatusSave
    }
  }, [_vm._v("确认成绩\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": _vm.pre
    }
  }, [_vm._v("上一位\n      ")]), _vm._v(" "), (_vm.user.type == '考官') ? _c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "0 10px"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("保存\n      ")]) : _vm._e(), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": _vm.nex
    }
  }, [_vm._v("下一位\n      ")])], 1)], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "请输入您的身份证号"
    },
    on: {
      "confirm": _vm.numConfirm
    },
    model: {
      value: (_vm.numShow),
      callback: function($$v) {
        _vm.numShow = $$v
      },
      expression: "numShow"
    }
  }, [_c('van-field', {
    attrs: {
      "label": "身份证号",
      "size": "large",
      "placeholder": "请输入您的身份证号码",
      "clearable": ""
    },
    model: {
      value: (_vm.userNum),
      callback: function($$v) {
        _vm.userNum = $$v
      },
      expression: "userNum"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eba9a550","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameScoreDetail.vue
// module id = 2629
// module chunks = 0